import { makeStyles } from '@material-ui/core/styles';

const useProfileStyles = makeStyles((theme) => ({
	textField: {
		width: '100%',
		marginBottom: '20px',
	},
}));

export { useProfileStyles };
